<template>
  <div>
    <el-dialog
      :title="`${isTaskEdit ? '修改任务' : '添加任务'}`"
      :visible="taskDialog"
      width="820px"
      @close="taskClose"
      v-if="taskDialog"
    >
      <el-form :model="taskForm" class="new-input-box"  label-width="auto">
        <el-form-item
          label="任务类型:"
          label-position="right"
          required
        >
          <el-select
            v-model="taskForm.taskType"
            style="width: 350px"
            placeholder="请选择任务类型"
            @change="taskTypeChange"
          >
            <el-option
              v-for="item in taskTypeOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
              :disabled="alreadySelectList.includes(item.value)"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <div class="task-tip-wrap">
          <jd-tip v-if="taskForm.taskType == 1">
            <span>任务说明：用户每日都可进入活动页签到，增加中奖概率。</span>
          </jd-tip>
          <jd-tip v-if="taskForm.taskType == 2">
            <span>任务说明：用户每日都可浏览店铺，增加中奖概率。</span>
          </jd-tip>
          <jd-tip v-if="taskForm.taskType == 3">
            <div>任务说明：</div>
            <div>1.用户浏览商品可以增加中奖概率;</div>
            <div>2.商品是以单个SKU为单位，浏览同一个商品多次按1次计算；</div>
          </jd-tip>
          <jd-tip v-if="taskForm.taskType == 4">
            <div>任务说明：</div>
            <div>1.用户加购商品可以增加中奖概率；</div>
            <div>2.商品是以单个SKU为单位，加购同一个商品多次按1次计算；</div>
          </jd-tip>
          <jd-tip v-if="taskForm.taskType == 5">
            <div>任务说明：</div>
            <div>1.此任务可以放链接，必须遵从以下规则：</div>
            <div>（1） 链接须包含 .isvjcloud.com，.isvjd.com或.jd.com</div>
            <div>（2） 只能以http://,https://开头</div>
            <div>2.用户每日都可以进入活动做任务。</div>
          </jd-tip>
          <jd-tip v-if="taskForm.taskType == 9">
            <div>任务说明：</div>
            <div>1.用户分享商品可以增加中奖概率；</div>
            <div>2.商品是以单个SKU为单位，加购同一个商品多次按1次计算；</div>
          </jd-tip>
          <jd-tip v-if="taskForm.taskType == 10">
            <span>任务说明：用户分享店铺可以增加中奖概率；</span>
          </jd-tip>
          <jd-tip v-if="taskForm.taskType == 11">
            <span>任务说明：用户分享活动可以增加中奖概率；</span>
          </jd-tip>
          <jd-tip class="task-tip" v-if="taskForm.taskType == 12">
            <div>任务说明：</div>
            <div>1.用户成功预约商品可以提高中奖概率；</div>
            <div>2.商品是以单个SKU为单位，预约同一个商品多次按1次计算；</div>
            <div>3.用户在活动时间期间内可以做此任务。</div>
          </jd-tip>
          <jd-tip v-if="taskForm.taskType == 16">
            <span>任务说明：用户可消耗积分兑换幸运值，增加中奖概率。</span>
          </jd-tip>
          <jd-tip v-if="taskForm.taskType == 17">
            <div>1、因官方接口限制，POP统计订单实付金额，自营统计订单金额（是指京东后台价，不等于商城前台页面展示的价格，前台页面无法查看该后台价格；如需查询后台价格，请联系采销核实。）；</div>
            <div>2、任务说明：用户每日下单即可有机会增加中奖概率</div>
            <div>3、如设置【购物任务】条件，则活动对象设置必须为会员身份，接口限制非会员无法统计交易数据。</div>
          </jd-tip>
          <jd-tip v-if="taskForm.taskType == 18">
            <div>
              任务说明：用户邀请好友成功入会，可增加中奖率；
            </div>
          </jd-tip>
          <jd-tip v-if="taskForm.taskType == 7">
            <span>任务说明：用户可参与入会任务，增加中奖概率。</span>
          </jd-tip>
          <jd-tip v-if="taskForm.taskType == 6">
            <span>任务说明：用户一键关注店铺可以增加中奖概率；</span>
          </jd-tip>
          <jd-tip class="task-tip" v-if="taskForm.type == 23">
            <div>任务说明：此任务可以放搜索关键词，用户进入活动点击去搜索自动带【关键词】跳转至APP查询页查询；</div>
          </jd-tip>
        </div>
        <el-form-item
          label="任务有效期:"
          required
          v-if="taskForm.taskType"
        >
          <div class="task-wrap">
            <div class="task-wrap-radio">
              <el-radio
                v-model="taskForm.taskValidity"
                :label="1"
                @change="onValidityChange"
                >活动期间</el-radio
              >
              <el-radio
                v-model="taskForm.taskValidity"
                :label="2"
                @change="onValidityChange"
                >指定日期</el-radio
              >
            </div>
            <div class="my_select_time" v-if="taskForm.taskValidity == 2">
              <el-date-picker
                prefix-icon="no_icon"
                v-model="taskForm.startTime"
                type="date"
                placeholder="开始日期"
                size="small"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                style="width: 120px; font-size: 12px"
                class="time1"
                :clearable="false"
                :picker-options="validStartPickerOptions"
                @change="validStartTimeChange"
              >
              </el-date-picker>
              <div class="time_to_text">至</div>
              <el-date-picker
                prefix-icon="no_icon"
                v-model="taskForm.endTime"
                type="date"
                placeholder="结束日期"
                size="small"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                style="width: 120px; font-size: 12px"
                class="time2"
                :clearable="false"
                :picker-options="validEndPickerOptions"
                @change="validEndTimeChange"
              >
              </el-date-picker>
              <i class="el-icon-circle-close date_icon1" @click="clearTime"></i>
              <img
                src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/select_date.svg"
                alt=""
                class="date_icon2"
              />
            </div>
          </div>
        </el-form-item>
        <el-form-item
          label="跳转链接:"
          required
          v-if="taskForm.taskType == 5"
        >
          <el-input v-model="taskForm.jumpUrl"></el-input>
          <div>
            <span class="tip-red">注：跳转的链接必须为京东链接</span>
          </div>
        </el-form-item>
        <el-form-item label="搜索关键词:" v-if="taskForm.taskType == 23" label-width="110px" required>
          <el-input 
            style="width: 320px;" 
            v-model="taskForm.searchKeyword" 
            placeholder="请输入搜索关键词，例【橙汁】"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="任务条件:"
          required
          v-if="taskForm.taskType"
        >
          <!-- 购买商品 -->
          <div class="rule_box" v-if="taskForm.taskType == 17">
            <div class="rule_box_top">
              所下订单需满足以下条件即可解锁成功（按累计订单统计）
            </div>
            <div class="rule_box_middle">
              <el-form-item label="下单店铺:" required>
                <orderShopCom
                  :venderIds.sync="taskForm.venderIds"
                  :multiShopGoods.sync="multiShopGoods"
                  :sellerSkuList.sync="taskForm.sellerSkuList"
                />
              </el-form-item>
              <el-form-item label="下单时间:" required>
                <span class="label-right">用户在</span>
                <div class="my_select_time">
                  <el-date-picker
                    prefix-icon="no_icon"
                    v-model="taskForm.orderStartTime"
                    type="datetime"
                    placeholder="选择日期时间"
                    size="small"
                    format="yyyy-MM-dd HH:mm:ss"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    style="width: 185px; font-size: 12px"
                    class="time1"
                    :clearable="false"
                    :picker-options="orderStartPickerOptions"
                  >
                  </el-date-picker>
                  <div class="time_to_text">至</div>
                  <el-date-picker
                    prefix-icon="no_icon"
                    v-model="taskForm.orderEndTime"
                    default-time="23:59:59"
                    type="datetime"
                    placeholder="选择日期时间"
                    size="small"
                    format="yyyy-MM-dd HH:mm:ss"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    style="width: 185px; font-size: 12px"
                    class="time2"
                    :clearable="false"
                    :picker-options="orderEndPickerOptions"
                    @change="orderEndTimeChange"
                  >
                  </el-date-picker>
                  <i
                    class="el-icon-circle-close date_icon1"
                    @click="clearOrderTime"
                  ></i>
                  <img
                    src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/select_date.svg"
                    alt=""
                    class="date_icon2"
                  />
                </div>
                <span class="label-left">期间内下单</span>
              </el-form-item>
              <el-form-item label="金额统计类型:" required>
                <el-radio-group
                  v-model="taskForm.orderPaymentType"
                >
                  <el-radio :label="1">
                    <span>订单金额（后台价）</span>
                    <el-tooltip class="item" effect="dark" content="是指京东后台价，不等于商城前台页面展示的价格，前台页面无法查看该后台价格；如需查询后台价格，请联系采销核实。" placement="top-start">
                      <div class="new-icon-box" style="margin: -3px 8px"></div>
                    </el-tooltip>
                  </el-radio>
                  <el-radio :label="0" v-if="!isVenderType">
                    <span>用户应付金额</span>
                    <el-tooltip class="item" effect="dark" content="订单商品原价总额-订单优惠总额+订单运费+税费+调整运费金额=用户应付金额" placement="top-start">
                      <div class="new-icon-box" style="margin: -3px 8px"></div>
                    </el-tooltip>
                  </el-radio>
                  <el-radio :label="2" v-if="!isVenderType">
                    <span>用户实付金额</span>
                    <el-tooltip class="item" effect="dark" content="用户应付金额-支付优惠总额=用户实付金额" placement="top-start">
                      <div class="new-icon-box" style="margin: -3px 8px"></div>
                    </el-tooltip>
                  </el-radio>
                </el-radio-group>
              </el-form-item>
              <!-- <el-form-item label="金额统计类型:" required>
                <el-radio-group
                  v-model="taskForm.countType"
                >
                  <el-radio :disabled="isVenderType" :label="0"> 实付金额 </el-radio>
                  <el-radio :label="1"> 订单金额 </el-radio>
                </el-radio-group>
                <div style="color: red">
                  注意：由于接口原因，自营仅支持统计订单金额，pop可按需选择统计实付金额或订单金额。
                </div>
              </el-form-item> -->
              <el-form-item label="商品要求:" required>
                <!-- <el-radio-group
                  v-model="taskForm.skuType"
                  @change="filterTypeChange"
                >
                  <el-radio :label="0">全部</el-radio>
                  <el-radio :label="1">指定商品</el-radio>
                  <el-radio :label="2">排除商品</el-radio>
                </el-radio-group>
                <jd-button
                  type="default"
                  :style="{
                    margin: ' 0 0px 0 15px',
                  }"
                  @click="exposureProducts"
                  :disabled="taskForm.skuType == 0"
                >
                  {{
                    taskForm.selectGoodsFilterArr.length != ""
                      ? "已选" + taskForm.selectGoodsFilterArr.length + "个"
                      : "+添加"
                  }}
                </jd-button> -->
                <productReqCom
                  :filterType.sync="taskForm.skuType"
                  :venderIds.sync="taskForm.venderIds"
                  :sellerSkuList.sync="taskForm.sellerSkuList"
                  :multiShopGoods.sync="multiShopGoods"
                  :isCreated="isCreated"
                  :isShowExclude="false"
                  :limitNum="goodsLimit"
                  addGoodText="选择商品"
                />
              </el-form-item>
              <el-form-item label="订单拆单后是否合并:" label-width="160px" required>
                <el-radio-group
                  v-model="taskForm.mergeOrder"
                >
                  <el-radio :label="false">否</el-radio>
                  <el-radio :label="true">是</el-radio>
                </el-radio-group>
                <jd-button type="blueText" class="ml12" @click="viewMergeLogic">查看合并拆单逻辑</jd-button>
              </el-form-item>
              <!-- 指定商品规则：仅商品要求为"指定商品"时展示，0=整单计算 1=仅统计指定商品金额和件数 -->
              <el-form-item label="指定商品规则:" v-if="taskForm.orderPaymentType==1&&taskForm.skuType == 1">
                <el-select style="width: 280px;" v-model="taskForm.statsSkuType" placeholder="">
                  <el-option label="只要订单包含指定商品就整单计算" :value="0"></el-option>
                  <el-option label="仅统计订单内指定商品的金额和件数" :value="1"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="订单状态:" required>
                <el-radio-group v-model="taskForm.orderType">
                  <el-radio :label="1">已完成</el-radio>
                  <el-radio :label="0"
                    >已付款（下单付款后即可统计（预售商品需要支付尾款才统计））</el-radio
                  >
                </el-radio-group>
              </el-form-item>
              <el-form-item label="消费门槛:" required>
                <span class="label-right">订单金额</span>
                <el-input
                  v-model="taskForm.orderStartPayment"
                  @input="
                    taskForm.orderStartPayment = taskForm.orderStartPayment =
                      getNumberData(1, $event, 1, 0)
                  "
                  style="width: 140px"
                  placeholder="请输入"
                ></el-input
                ><span class="label-left label-right">元，且商品件数</span>
                <el-input
                  v-model="taskForm.itemStartCount"
                  @input="
                    taskForm.itemStartCount = getNumberData(
                      1,
                      $event,
                      0,
                      1,
                      999999
                    )
                  "
                  style="width: 140px"
                  placeholder="请输入"
                ></el-input>
                <span class="label-left">件</span>
              </el-form-item>
              <el-form-item label="统计方式:" required>
                <el-radio-group v-model="taskForm.orderCountType">
                  <el-radio :label="1">累计订单</el-radio>
                  <el-radio :label="0">单笔订单</el-radio>
                </el-radio-group>
              </el-form-item>
            </div>
          </div>
          <!-- 浏览商品、浏览商品 -->
          <span v-else-if="[3, 4, 9, 10, 11, 12].includes(taskForm.taskType)">
            <span class="label-right" v-if="taskForm.taskType == 3"
              >成功浏览</span
            >
            <span class="label-right" v-else-if="taskForm.taskType == 4"
              >成功加购</span
            >
            <span
              class="label-right"
              v-else-if="[9, 10, 11].includes(taskForm.taskType)"
              >成功分享</span
            >
            <span
              class="label-right"
              v-else-if="[12].includes(taskForm.taskType)"
              >成功预约</span
            >
            <el-input
              v-model.number="taskForm.taskCondition"
              placeholder="请输入"
              style="width: 70px"
              @input="
                taskForm.taskCondition = getNumberData(
                  1,
                  $event,
                  0,
                  1,
                  99999999
                )
              "
            ></el-input>
            <span
              class="label-left"
              v-if="[3, 4, 12].includes(taskForm.taskType)"
              >件商品</span
            >
            <span class="label-left" v-else-if="[9].includes(taskForm.taskType)"
              >次商品</span
            >
            <span
              class="label-left"
              v-else-if="[10].includes(taskForm.taskType)"
              >次店铺</span
            >
            <span
              class="label-left"
              v-else-if="[11].includes(taskForm.taskType)"
              >次活动</span
            >
          </span>
          <!-- 积分兑换 -->
          <span v-else-if="taskForm.taskType == 16">
            消耗
            <el-input
              v-model.number="taskForm.taskCondition"
              placeholder="请输入"
              style="width: 70px"
              @input="
                taskForm.taskCondition = getNumberData(
                  1,
                  $event,
                  0,
                  1,
                  99999999
                )
              "
            ></el-input>
            积分
          </span>
          <span v-else-if="taskForm.taskType == 18">
            成功邀请
            <el-input
              v-model.number="taskForm.inviteLimit"
              placeholder="请输入"
              style="width: 70px"
              @input="taskForm.inviteLimit = getNumberData(1, $event, 0, 1, 99999999)"
            ></el-input>
            个好友入会
          </span>
          <div v-else-if="taskForm.taskType == 5" class="flexc-cen-x">
            <span>成功浏览当前链接</span>
            <el-input
              class="ml8"
              style="width: 100px"
              v-model="taskForm.viewTime"
              @input="taskForm.viewTime = getNumberData(1, $event, 0, 1)"
            ></el-input>
            <span class="ml8">秒</span>
          </div>
          <span v-else>{{ taskForm.taskCondition }}</span>
        </el-form-item>
        <el-form-item
          label="浏览商品:"
          required
          v-if="taskForm.taskType == 3"
        >
          <jd-button type="blue" @click="showGoods(100)"
            >选择商品（{{ taskForm.itemListForFilter.length }}/100）</jd-button
          >
        </el-form-item>
        <el-form-item
          label="加购商品:"
          required
          v-if="taskForm.taskType == 4"
        >
          <jd-button type="blue" @click="showGoods(100)"
            >选择商品（{{ taskForm.itemListForFilter.length }}/100）</jd-button
          >
        </el-form-item>
        <el-form-item
          label="分享商品:"
          required
          v-if="taskForm.taskType == 9"
        >
          <jd-button type="blue" @click="showGoods(1)"
            >选择商品（{{ taskForm.itemListForFilter.length }}/1）</jd-button
          >
        </el-form-item>
        <el-form-item
          label="预约商品:"
          required
          v-if="taskForm.taskType == 12"
        >
          <div class="task-wrap">
            <jd-button type="blue" @click="showGoods(100)"
              >选择商品（{{
                taskForm.itemListForFilter.length
              }}/100）</jd-button
            >
            <span class="tip-red label-left"
              >注意：请添加预约商品，非预约商品无法完成任务</span
            >
          </div>
        </el-form-item>
        <el-form-item
          label="任务奖励:"
          label-position="right"
          required
          v-if="taskForm.taskType"
        >
          完成任务赠送
          <el-input
            v-model.number="taskForm.giveLimit"
            placeholder="请输入"
            style="width: 70px"
            @input="
              taskForm.giveLimit = getNumberData(1, $event, 0, 1, limitGiftNum)
            "
          ></el-input>
          {{ giftText }}
        </el-form-item>
        <el-form-item
          label="兑换次数:"
          label-position="right"
          required
          v-if="taskForm.taskType == 16"
        >
          <el-select
            v-model="taskForm.activityType"
            placeholder="请选择"
            style="width: 120px"
          >
            <el-option label="活动期间" :value="2"></el-option>
            <el-option label="每日" :value="1"></el-option>
          </el-select>
          <span class="label-left label-right">最多兑换</span>
          <el-input
            v-model.number="taskForm.finishLimit"
            placeholder="请输入"
            style="width: 70px"
            @input="
              taskForm.finishLimit = getNumberData(1, $event, 0, 0, 99999999)
            "
          ></el-input>
          次
        </el-form-item>
        <el-form-item label="任务次数:" required v-if="taskForm.taskType&&taskForm.taskType!=16">
          <span>
          {{taskValidityType[taskForm.taskValidity]}}{{dayTaskType.includes(taskForm.taskType) ? '每日' : ''}}最多完成
            <el-input
            v-if="!taskTypesList.includes(taskForm.taskType)"
              v-model.number="taskForm.taskDoLimit"
              placeholder="请输入"
              style="width: 70px"
              @input="taskForm.taskDoLimit = getNumberData(1, $event, 0, 1,99999999)"
            ></el-input>
            <span v-else>1</span>
            次
          </span>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <jd-button style="margin-right: 8px" @click="taskClose">取消</jd-button>
        <jd-button type="blue" @click="sureTask">确定</jd-button>
      </div>
    </el-dialog>
    <!-- 指定购买商品 -->
    <!-- 购买商品-指定购买商品 -->
    <selectGoodsMonitor
      v-if="selectGoodsStateFilter"
      ref="selectGo"
      :isShow="selectGoodsStateFilter"
      @close="selectGoodsCloseFilter"
      :selectGoods="taskForm.selectGoodsFilterArr"
      :moduleType="true"
      :skuSearch="true"
      isInteract
    ></selectGoodsMonitor>
    <!-- 商品要求 -->
    <selectGoodsMonitor
      v-if="selectGoods"
      ref="selectGo"
      :isShow="selectGoods"
      @close="selectGoodsClose"
      :selectGoods="taskForm.itemListForFilter"
      :moduleType="true"
      :skuSearch="true"
      :isLimit="isLimit"
      :limitNum="goodsLimit"
      isInteract
    ></selectGoodsMonitor>
  </div>
</template>
<script>
import selectGoodsMonitor from "@/components/selectGoodsMonitor2.vue";
import orderShopCom from "./multipleStoreSetting/orderShopCom.vue";
import productReqCom from "./multipleStoreSetting/productReqCom.vue";
import { getTaobaoItemListSku } from "@/api/jhk/analysis/ware-controller";
import { useValidateMultiShopGoods } from "@/views/interactiveMarketing/activity/components/commDataHook/useBasicInformation.js";
export default {
  name: "",
  components: {
    selectGoodsMonitor,
    orderShopCom,
    productReqCom,
  },
  mixins: [],
  props: {
    taskDialog: {
      type: Boolean,
      default: false,
    },
    isTaskEdit: {
      type: Boolean,
      default: false,
    },
    taskData: {
      type: Object,
      default: () => ({}),
    },
    taskTypeOptions: {
      type: Array,
      default: () => [],
    },
    taskDataLists: {
      type: Array,
      default: () => [],
    },
    currentIndex: {
      type: Number,
      default: 0,
    },
    // 活动详情
    ruleForm: {
      type: Object,
      default: () => ({}),
    },
    giftText: {
      type: String,
      default: "次抽奖机会",
    },
    // 是否去掉任务有效期的默认时间
    isNotDefaultTaskTime: {
      type: Boolean,
      default: false,
    },
    // 完成任务赠送礼物数量限制
    limitGiftNum: {
      type: Number,
      default: 999999,
    },
    // 是否自营
    venderType: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      taskValidityType: {
        1: "活动期间",
        2: "指定时间",
      },
      taskTypesList:[1,2,3,4,6,7,9,10,11,5,23],
      dayTaskType: [1,2,3,4,9,10,11,5,23],
      actTaskType: [12,17,18],
      isCreated: false,
      isPremissionShow: true,
      selectGoods: false,
      isLimit: false,
      goodsLimit: 100,
      selectGoodsStateFilter: false,
      includeArr: [], //指定商品
      excludeArr: [], //排除商品
      taskForm: {
        taskType: "",
        taskValidity: 1,
        startTime: "",
        endTime: "",
        taskCondition: "",
        skuType: 0,
        statsSkuType: 0, // 指定商品规则 0:整单计算 1:仅统计指定商品金额和件数
        giveLimit: "",
        orderStartTime: "", //下单时间
        orderEndTime: "",
        orderPaymentType: 1,
        skuType: 0,
        orderType: 1,
        itemStartCount: null,
        orderStartPayment: null,
        itemListForFilter: [], // 商品要求
        selectGoodsFilterArr: [], // 下单-商品要求
        jumpUrl: null,
        activityType: 2,
        orderCountType: 1,
        inviteLimit: null,
        taskDoLimit: null,
        venderIds: [],
        sellerSkuList: [],
        mergeOrder: false,
      },
      multiShopGoods: [],
      taskDataList: [],
      goodsTypeList: [3, 4, 9, 12],
      conditionValue: [3, 4, 9, 10, 11, 12, 16,18], //taskCondion有其他值的类型
      goodsLimitList: [],
      orderStartPickerOptions: {
        disabledDate: (time) => {
          if (this.taskForm.orderEndTime) {
            return (
              time.getTime() >
              new Date(this.taskForm.orderEndTime).valueOf() - 8.64e7
            );
          } else {
            return false;
          }
        },
      },
      // 下单结束时间<=活动结束时间
      orderEndPickerOptions: {
        disabledDate: (time) => {
          return (
            (this.taskForm.orderStartTime &&
              time.getTime() <
                new Date(this.taskForm.orderStartTime).valueOf()) ||
            (this.ruleForm.endTime &&
              time.getTime() > new Date(this.ruleForm.endTime).valueOf()) ||
            (this.ruleForm.timingPrizeTime &&
              time.getTime() >
                new Date(this.ruleForm.timingPrizeTime).valueOf())
          );
        },
      },
      validStartPickerOptions: {
        disabledDate: (time) => {
          return (
            (this.ruleForm.startTime &&
              time.getTime() <
                new Date(this.ruleForm.startTime).valueOf() - 8.64e7) ||
            (this.ruleForm.endTime &&
              time.getTime() > new Date(this.ruleForm.endTime).valueOf()) ||
            (this.taskForm.endTime &&
              time.getTime() > new Date(this.taskForm.endTime).valueOf())
          );
        },
      },
      validEndPickerOptions: {
        disabledDate: (time) => {
          return (
            (this.taskForm.startTime &&
              time.getTime() < new Date(this.taskForm.startTime).valueOf()) ||
            (this.ruleForm.timingPrizeTime &&
              time.getTime() >
                new Date(this.ruleForm.timingPrizeTime).valueOf())
          );
        },
      },
    };
  },
  computed: {
    alreadySelectList() {
      let taskTypeList = this.taskDataLists.map((item) => {
        return item.taskType;
      });
      return taskTypeList;
    },
    //权限判断
    permissions() {
      return this.$store.getters.loginUserInfo.permissions;
    },
    venderId() {
      return this.$store.getters.loginUserInfo.venderId;
    },
    isVenderType() {
      return this.multiShopGoods.some((item) => item.venderType);
    },
    isPop() {
      return this.multiShopGoods.every((item) => !item.venderType);
    },
  },
  watch: {
    permissions:{
      handler(nVal, oVal) {
        if (nVal.indexOf("hide:interactive:product:offline") != "-1") {
         this.isPremissionShow = false;
        }
      },
      immediate: true,
    },
    // 只选pop店铺
    // isPop(newVal) {
    //   if(newVal) {
    //     this.taskForm.countType = 0
    //   } else {
    //     this.taskForm.countType = 1
    //   }
    // },
    //自营和pop店铺其中一个或只有自营
    isVenderType(newVal) {
      if(newVal) {
        this.taskForm.orderPaymentType = 1
      }
      //  else {
      //   this.taskForm.countType = 0
      // }
    },
  },
  created() {
    if (!this.isTaskEdit) {
      if (this.venderType) {
        this.taskForm.orderPaymentType = 1;
      }
    } else {
      this.isCreated = true
      this.taskForm = this.taskData;
      // 老数据无 statsSkuType 时兜底为 0（整单计算）
      this.taskForm.statsSkuType = this.taskData.statsSkuType || 0;
      if(this.taskForm.taskType == 17) {
        this.goodsLimit = 500
      } else {
        this.goodsLimit = 100
      }
    }
    this.taskDataList = this.taskDataLists;
    this.initData();
  },
  methods: {
    viewMergeLogic() {
      window.open("https://www.yuque.com/yunduanxincrm/mrkpcq/mub1q6wafxefavp4?singleDoc#")
    },
    initData() {
      this.taskForm.venderIds = this.taskForm.venderIds.length> 0 ? this.taskForm.venderIds : [this.venderId];
      this.taskForm.sellerSkuList = this.taskForm.sellerSkuList&&this.taskForm.sellerSkuList.length> 0 ? this.taskForm.sellerSkuList : [
        {
          venderId: this.venderId,
          skuIds: [],
          itemList: [],
        },
      ];
      this.multiShopGoods = useValidateMultiShopGoods(this, this.taskForm.venderIds);
    },
    // 切换指定日期 默认回显活动范围时间
    onValidityChange(val) {
      if (val == 2) {
        if (this.isNotDefaultTaskTime) return;
        this.taskForm.startTime = this.ruleForm.startTime || "";
        this.taskForm.endTime = this.ruleForm.endTime || "";
      } else {
        this.taskForm.startTime = "";
        this.taskForm.endTime = "";
      }
    },
    // 任务有效期
    clearTime() {
      this.taskForm.startTime = "";
      this.taskForm.endTime = "";
    },
    // 购买商品-商品要求
    filterTypeChange(val) {
      if (val == 0) {
        this.taskForm.selectGoodsFilterArr = [];
      } else if (val == 1) {
        this.taskForm.selectGoodsFilterArr = this.includeArr;
      } else if (val == 2) {
        this.taskForm.selectGoodsFilterArr = this.excludeArr;
      }
    },
    // 购买商品-添加指定商品弹窗
    exposureProducts() {
      this.selectGoodsStateFilter = true;
      if (this.taskForm.skuType == 1) {
        this.taskForm.selectGoodsFilterArr =  this.taskForm.selectGoodsFilterArr.concat(this.includeArr);
      } else if (this.taskForm.skuType == 2) {
        this.taskForm.selectGoodsFilterArr =  this.taskForm.selectGoodsFilterArr.concat(this.excludeArr);
      }
    },
    // 购买商品-选择指定商品数据回调
    selectGoodsCloseFilter(data) {
      if (data) {
        let isGoods = false;
        data.forEach((item) => {
          if (item.skuStatus != 1) {
            isGoods = true;
          }
        });
        if(this.isPremissionShow){
         if (isGoods) {
           return this.$message.warning("当前所选商品包含下架商品，请重新选择");
         }
        }
        let selectGoodsArr = [];
        data.forEach((value, index) => {
          let fomeVaule = {};
          fomeVaule.skuId = data[index].skuId;
          fomeVaule.logo = data[index].logo;
          fomeVaule.price = data[index].jdPrice || data[index].price;
          fomeVaule.title = data[index].wareTitle || data[index].title;
          selectGoodsArr.push(fomeVaule);
        });
        if (this.taskForm.skuType == 1) {
          this.includeArr = selectGoodsArr;
        } else if (this.taskForm.skuType == 2) {
          this.excludeArr = selectGoodsArr;
        }
        this.taskForm.selectGoodsFilterArr = selectGoodsArr;
      }
      this.selectGoodsStateFilter = false;
    },
    // 商品要求
    exposureProductsFiter() {
      this.isLimit = false;
      this.selectGoods = true;
    },
    //商品要求-数据回调
    selectGoodsClose(data) {
      if (data) {
        let isGoods = false;
        data.forEach((item) => {
          if (item.skuStatus != 1) {
            isGoods = true;
          }
        });
        if(this.isPremissionShow){
         if (isGoods) {
           return this.$message.warning("当前所选商品包含下架商品，请重新选择");
         }
       }
        let selectGoodsArr = [];
        data.forEach((value, index) => {
          let fomeVaule = {};
          fomeVaule.skuId = data[index].skuId;
          fomeVaule.logo = data[index].logo;
          fomeVaule.price = data[index].jdPrice || data[index].price;
          fomeVaule.title = data[index].wareTitle || data[index].title;
          selectGoodsArr.push(fomeVaule);
        });
        this.taskForm.itemListForFilter = selectGoodsArr;
      }
      this.selectGoods = false;
    },
    // 确认添加任务
    sureTask() {
      if (!this.taskForm.taskType) {
        return this.$message.warning("请选择任务类型");
      }
      // 任务有效期
      if (this.taskForm.taskValidity == 2) {
        if (!this.taskForm.startTime || !this.taskForm.endTime) {
          return this.$message.warning("请填写任务有效期");
        }
      }
      // 任务条件
      if (this.conditionValue.includes(this.taskForm.taskType)) {
        if (this.taskForm.taskType == 18) {
          if (!this.taskForm.inviteLimit) {
            return this.$message.warning("请填写邀请人数");
          }
        } else {
          if (!this.taskForm.taskCondition) {
            return this.$message.warning("请填写任务条件");
          }
        }
      }
      // 浏览会场
      if (this.taskForm.taskType == 5) {
        if (!this.taskForm.jumpUrl) {
          return this.$message.warning("请填写跳转链接");
        }
        if (/^(http:\/\/|https:\/\/)/.test(this.taskForm.jumpUrl)) {
          if (
            !/isvjcloud\.com/.test(this.taskForm.jumpUrl) &&
            !/isvjd\.com/.test(this.taskForm.jumpUrl) &&
            !/jd\.com/.test(this.taskForm.jumpUrl)
          ) {
            return this.$message.warning("请填写正确跳转链接");
          }
        } else {
          return this.$message.warning("请填写正确跳转链接");
        }
        if(!this.taskForm.viewTime){
          return this.$message.warning('请输入浏览时间')
        } 
        if(!this.taskForm.giveLimit){
          return this.$message.warning('请输入抽奖次数')
        }
      }
      // 搜索关键词
      if (this.taskForm.taskType == 23) {
        if (!this.taskForm.searchKeyword) {
          return this.$message.warning("请输入搜索关键词");
        }
      }
      if (this.taskForm.taskType == 17) {
        if (!this.taskForm.orderStartTime || !this.taskForm.orderEndTime) {
          return this.$message.warning("请选择下单时间");
        }
        // if (
        //   this.taskForm.skuType != 0 &&
        //   !this.taskForm.selectGoodsFilterArr.length
        // )
        //   return this.$message.warning(
        //     this.taskForm.skuType == 2 ? "请选择排除商品" : "请选择指定商品"
        //   );
        if (this.taskForm.skuType == 1) {
          const obj = this.taskForm.sellerSkuList.find((item) => {
            return item.skuIds.length == 0;
          });
          if (obj) {
            const shop = this.multiShopGoods.find((item) => {
              return item.venderId == obj.venderId;
            });
            const skuTypes= {
              1: "指定",
              2: "排除",
            }
            return this.$message.warning(`请选择${shop.shopTitle}的${skuTypes[this.taskForm.skuType]}商品`);
          }
        }
        if (!this.taskForm.itemStartCount && !this.taskForm.orderStartPayment) {
          return this.$message.warning("请填写消费门槛");
        }
      }
      // 商品
      if (this.goodsTypeList.includes(this.taskForm.taskType)) {
        if (this.taskForm.taskType == 3) {
          if (this.taskForm.itemListForFilter.length == 0) {
            return this.$message.warning(`请选择浏览商品`);
          }
        }
        if (this.taskForm.taskType == 4) {
          if (this.taskForm.itemListForFilter.length == 0) {
            return this.$message.warning(`请选择加购商品`);
          }
        }
        if (this.taskForm.taskType == 9) {
          if (this.taskForm.itemListForFilter.length == 0) {
            return this.$message.warning(`请选择分享商品`);
          }
        }
        if (this.taskForm.taskType == 12) {
          if (this.taskForm.itemListForFilter.length == 0) {
            return this.$message.warning(`请选择预约商品`);
          }
        }
      }

      if (!this.taskForm.giveLimit) {
        return this.$message.warning("请填写任务奖励");
      }
      if (this.taskForm.taskType == 16 && !this.taskForm.finishLimit) {
        return this.$message.warning("最多兑换次数不能为空");
      }
      if (this.actTaskType.includes(this.taskForm.taskType) && !this.taskForm.taskDoLimit) {
        return this.$message.warning(`${this.taskValidityType[this.taskForm.taskValidity]}最多完成次数不能为空`);
      }
      const obj = JSON.parse(JSON.stringify(this.taskForm));

      if (this.isTaskEdit) {
        this.taskDataList.splice(this.currentIndex, 1, obj);
      } else {
        this.taskDataList.push(obj);
      }
      this.$emit("getTaskDataList", this.taskDataList);
      console.log("taskDataList>>", this.taskDataList);
    },
    // 关闭
    taskClose() {
      this.$emit("closeTask");
    },
    // 任务类型change
    taskTypeChange(e) {
      const obj = this.taskTypeOptions.find((item) => item.value == e);
      this.taskForm.taskCondition = obj.taskCondition || "";
      this.taskForm.taskValidity = 1;
      this.taskForm.giveLimit = "";
      if(e==17) {
        this.goodsLimit = 500
        this.initData()
      } else {
        this.goodsLimit = 100
      }
    },
    // 清空下单时间
    clearOrderTime() {
      this.taskForm.orderStartTime = null;
      this.taskForm.orderEndTime = null;
    },
    // 下单时间
    orderEndTimeChange() {
      if (this.ruleForm.timingPrizeTime) {
        if (
          this.isSameDay(
            this.ruleForm.timingPrizeTime,
            this.taskForm.orderEndTime
          ) &&
          new Date(this.taskForm.orderEndTime).valueOf() >
            new Date(this.ruleForm.timingPrizeTime).valueOf()
        ) {
          this.taskForm.orderEndTime = this.ruleForm.timingPrizeTime;
        }
        return;
      }
      if (this.ruleForm.endTime) {
        if (
          this.isSameDay(this.ruleForm.endTime, this.taskForm.orderEndTime) &&
          new Date(this.taskForm.orderEndTime).valueOf() >
            new Date(this.ruleForm.endTime).valueOf()
        ) {
          this.taskForm.orderEndTime = this.ruleForm.endTime;
        }
      }
    },
    // 任务有效期-开始
    validStartTimeChange() {
      if (this.ruleForm.startTime) {
        if (
          this.isSameDay(this.ruleForm.startTime, this.taskForm.startTime) &&
          new Date(this.taskForm.startTime).valueOf() <
            new Date(this.ruleForm.startTime).valueOf()
        ) {
          this.taskForm.startTime = this.ruleForm.startTime.split(" ")[0];
        }
      }
    },
    // 任务有效期-结束
    validEndTimeChange() {
      if (this.ruleForm.timingPrizeTime) {
        if (
          this.isSameDay(
            this.ruleForm.timingPrizeTime,
            this.taskForm.endTime
          ) &&
          new Date(this.taskForm.endTime).valueOf() >
            new Date(this.ruleForm.timingPrizeTime).valueOf()
        ) {
          this.taskForm.endTime = this.ruleForm.timingPrizeTime.split(" ")[0];
        }
      }
    },
    // 判断是否同一天
    isSameDay(date1, date2) {
      // 将日期转换为Date对象
      const d1 = new Date(date1);
      const d2 = new Date(date2);

      // 设置时间为午夜12点（这样可以忽略时分秒）
      d1.setHours(0, 0, 0, 0);
      d2.setHours(0, 0, 0, 0);

      // 比较年月日是否相同
      return d1.getTime() === d2.getTime();
    },
    // 商品弹窗
    showGoods(limit = 100) {
      this.goodsLimit = limit;
      this.isLimit = true;
      this.selectGoods = true;
    },
  },
};
</script>
<style lang="scss" scoped>
.task-tip-wrap {
  margin-bottom: 20px;
}
.task-wrap {
  display: flex;
  align-items: center;
  &-radio {
    margin-right: 10px;
  }
  .time-box {
    display: flex;
    align-items: center;
  }
}
.tip-type {
  margin: -2px 6px;
}
.task-tip {
  background-color: #f8f9fc;
  padding: 20px;
  border-radius: 4px;
}
.tip-red {
  color: red;
}
.condition-stype {
  margin-top: 16px;
  padding: 20px 0 1px;
  background-color: #f8f9fc;
}
.w90 {
  width: 60px;
}

.rule_box {
  width: 100%;
  background: #fafafa;
  padding-bottom: 10px;
  border-radius: 4px;
  font-size: 14px;
  margin-top: 0px;
  &_top {
    margin: 15px 0 10px 15px;
  }
  &_middle {
    margin-left: 10px;
    .middle-box {
      display: flex;
      align-items: center;
      &_tip {
        color: #ff0000;
      }
    }
  }
  &_bottom {
    margin-left: 7px;
  }
}

.label {
  &-right {
    margin-right: 8px;
  }
  &-left {
    margin-left: 8px;
  }
}
</style>
